module.exports = __webpack_public_path__ + "img/fashion_57.59e4b415.jpg";